import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, DialogActions, Avatar, FormControl, OutlinedInput, InputAdornment, Tabs, Tab, InputLabel } from '@material-ui/core';
import { fbButton, tw, reddit, pinterest, linkedin } from 'vanilla-sharing';
import { ThemeProvider } from '@material-ui/styles';
import { makeStyles, createStyles, Theme, createMuiTheme } from '@material-ui/core/styles';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import Snackbar from '../../Comman/Snackbar';

var QRCode = require('qrcode.react');

const theme = createMuiTheme({
  overrides: {
    MuiButton: {
      label: {
        filter: 'none',
        display: "block"
      },
    },
    MuiTab: {
      root: {
        minWidth: "72px !important"
      }
    },
    MuiInputAdornment: {
      root: {
        position: "inherit"
      }
    }
  },
});

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    qrCode: {
      height: "80%",
      margin: "15px",
      display: "flex",
      '& canvas': {
        margin: 'auto'
      }
    },
    large: {
      width: theme.spacing(6),
      height: theme.spacing(6),
      margin: "auto"
    },
    margin: {
      margin: theme.spacing(1),
      width: "100%"
    }
  }),
);

interface IShareAction {
  open: any;
  shareClose: any;
  url: any;
  name: any;
}

const ShareAction: React.FC<IShareAction> = ({ open, shareClose, url, name }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState(false);
  const [mainData, setMainData]: any = React.useState();
  const [mainDataSet, setMainDataSet]: any = React.useState();

  useEffect(() => {
    setMainData(localStorage.getItem("slugTermMain"));
    setMainDataSet(localStorage.getItem("slugTerm"));
  }, []);

  const mailSend = (selectedCard: any) => {
    window.open(`mailto:?subject="Share the chatContent"&body=${selectedCard}`, "_blank");
  }

  const getPocket = (selectedCard: any) => {
    window.open(`https://getpocket.com/edit?url=${selectedCard}`, "_blank");
  }

  const copyImg = async () => {
    try {
      var canvas: any = document.getElementById(url);
      let w: any = window;
      canvas.toBlob(async function (blob: any) {
        await w.navigator.clipboard.write([
          new w.ClipboardItem({
            [blob.type]: blob
          })
        ]);
        setIsOpen(true)
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={shareClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Share Social-Media</DialogTitle>
        <DialogContent>
          <ThemeProvider theme={theme}>
            {mainDataSet && mainDataSet.length > 0 ?
              <div><div>
                Please use the following QR-Code for redirect on <b>{name}</b><br />
                <div style={{ display: "flex" }}>
                  <b style={{ lineHeight: 2.5, marginRight: 5 }}>Copy QR Code Image:</b>
                  <Button variant="outlined" color="primary" onClick={() => copyImg()}>copy QR-Code</Button>
                </div>
                {/* <b>Link:</b> <a target="_blank" rel="noopener noreferrer" href={url}>{url}</a> */}
              </div>
                <div className={classes.qrCode}>
                  <QRCode
                    id={url}
                    value={url}
                    size={170}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"H"}
                    renderAs={"canvas"}
                  />
                </div></div>
              : <div>
                <div>
                  Please use the following QR-Code for redirect on <b>{mainData}</b><br />
                  <div style={{ display: "flex" }}>
                    <b style={{ lineHeight: 2.5, marginRight: 5 }}>Copy QR Code Image:</b>
                    <Button variant="outlined" color="primary" onClick={() => copyImg()}>copy QR-Code</Button>
                  </div>
                  {/* <b>Link:</b> <a target="_blank" rel="noopener noreferrer" href={`https://aws.glossary.chat/${mainData &&
                    mainData.replace(/ /g, "_").toLowerCase()}`}>{`https://aws.glossary.chat/${mainData &&
                    mainData.replace(/ /g, "_").toLowerCase()}`}</a> */}
                </div>
                <div className={classes.qrCode}>
                  <QRCode
                    id={url}
                    value={`https://honeycode.glossary.chat/${mainData && mainData.replace(/ /g, "_").toLowerCase()}`}
                    size={170}
                    bgColor={"#ffffff"}
                    fgColor={"#000000"}
                    level={"H"}
                    renderAs={"canvas"}
                  />
                </div></div>}
            <div style={{ display: "flex" }}>
              <Tabs
                value={0}
                variant="scrollable"
                scrollButtons="on"
                indicatorColor="primary"
                aria-label="scrollable force tabs"
              >
                <Tab
                  onClick={() => tw({
                    url: url,
                    title: "via @artificialchat",
                    hashtags: ["artificialchat", "bot"],
                  })}
                  label="Twitter"
                  icon={<Avatar src={`/twitter.png`} alt={"twitter"} className={classes.large} />}
                />
                <Tab
                  onClick={() => linkedin({
                    url: url,
                    title: "via @artificialchat",
                    description: "This is an email"
                  })}
                  label="Linkedin"
                  icon={<Avatar src={`/linkedin.png`} alt={"linkedin"} className={classes.large} />}
                />
                <Tab
                  onClick={() => mailSend(url)}
                  label="Gmail"
                  // icon={<Avatar src={`/gmail.png`} alt={"gmail"} className={classes.large} />}
                  icon={<MailOutlineIcon className={classes.large} />}
                />
                <Tab
                  onClick={() => reddit({
                    url: url,
                    title: "via @artificialchat",
                  })}
                  label="Reddit"
                  icon={<Avatar src={`/reddit.png`} alt={"reddit"} className={classes.large} />}
                />
                <Tab
                  onClick={() => pinterest({
                    url: url,
                    description: "This is an pinterest",
                  })}
                  label="Pinterest"
                  icon={<Avatar src={`/pinterest.png`} alt={"pinterest"} className={classes.large} />}
                />
                <Tab
                  onClick={() => fbButton({ url: url })}
                  label="Facebook"
                  icon={<Avatar src={`/facebook.png`} alt={"facebook"} className={classes.large} />}
                />
                <Tab
                  onClick={() => getPocket(url)}
                  label="Pocket"
                  icon={<Avatar src={`/getpocket.png`} alt={"pocket"} className={classes.large} />}
                />
              </Tabs>
            </div>

            <FormControl className={classes.margin} variant="outlined">
              <InputLabel htmlFor="outlined-adornment-password">
                Share URL
              </InputLabel>
              {mainDataSet && mainDataSet.length > 0 ? <OutlinedInput
                id="outlined-adornment-password"
                type='text'
                value={url}
                disabled
                labelWidth={70}
                endAdornment={
                  <InputAdornment position="end">
                    <Button color="primary" onClick={() => { navigator.clipboard.writeText(url); setIsOpen(true) }}	>
                      Copy
                  </Button>
                  </InputAdornment>
                }
              /> : <OutlinedInput
                  id="outlined-adornment-password"
                  type='text'
                  value={`https://honeycode.glossary.chat/${mainData &&
                    mainData.replace(/ /g, "_").toLowerCase()}`}
                  disabled
                  labelWidth={70}
                  endAdornment={
                    <InputAdornment position="end">
                      <Button color="primary" onClick={() => {
                        navigator.clipboard.writeText(`https://honeycode.glossary.chat/${mainData &&
                          mainData.replace(/ /g, "_").toLowerCase()}`); setIsOpen(true)
                      }}	>
                        Copy
                  </Button>
                    </InputAdornment>
                  }
                />}
            </FormControl>
          </ThemeProvider>
        </DialogContent>
        <DialogActions>
          <Button onClick={shareClose} color="primary" style={{ outline: "0" }}>
            Done
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar isOpen={isOpen} messageData={"Copy clipboard!"} onClose={() => setIsOpen(false)} />
    </div>
  );
};

export default ShareAction;

